// extracted by mini-css-extract-plugin
export default {"chevron":"Arrow__chevron___j1iA0"};